export default function ParcelType(type) {
  if (Number(type) === 1) {
    return "Normal Gönderi veya Numune";
  } else if (Number(type) === 2) {
    return "Hediye";
  } else if (Number(type) === 3) {
    return "Mikro İhracat (ETGB)";
  } else return null;
}
